import { connect, RenderingSDK, EnvType } from '@rendering/web-client';
import { apiPrefix } from 'src/settings';

let sdk: RenderingSDK | null = null;

/**
 * Resolve the rendering env from the current apiPrefix, throwing on unrecognized values.
 */
export function resolveEnv(prefix: string): EnvType {
    if (prefix === '') {
        return EnvType.Prod;
    }
    if (prefix === 'dev.') {
        return EnvType.Dev;
    }
    throw new Error(`Invalid API prefix: "${prefix}"`);
}

/**
 * Initialize the rendering SDK with authentication token
 * @param token - Authentication token from auth service
 * @returns Promise resolving to SDK instance
 */
export async function initSdk(token: string): Promise<RenderingSDK> {
    const env = resolveEnv(apiPrefix);
    sdk = await connect({ env, authToken: token });
    return sdk;
}

/**
 * Get the current SDK instance
 * @returns SDK instance
 * @throws Error if SDK not initialized
 */
export function getSdk(): RenderingSDK {
    if (!sdk) {
        throw new Error('Rendering SDK not initialized. Call initSdk first.');
    }
    return sdk;
}
